var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    {
      staticClass: "w100",
      style: { height: "100%;" },
      attrs: { value: true, "escape-close": "" },
    },
    [
      _c(
        "w-container",
        { style: { padding: "0 0 0 0" } },
        [
          _c(
            "w-row",
            { style: { height: "100%" }, attrs: { "no-margin": "" } },
            [
              _vm.link
                ? _c("iframe", { key: _vm.key, attrs: { src: _vm.link } })
                : _c("div", { staticClass: "waiting" }, [
                    _vm._v(" " + _vm._s(_vm.$ct("waiting-for-sale")) + " "),
                  ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }